import { injectToShader } from "utils"

export class Parameters {
  SIZE_RATIO = 1
  MARGIN = 0.05

  params: { [key: string]: number }
  randomValues: number[]

  constructor() {
    // params
    //const paletteWeightOpts = [weight(5, 0)]

    const params = {
      //paletteIndex: random("Palette index", paletteWeightOpts),
    }

    //const palette = palettes[params.paletteIndex]
    this.params = params
    this.randomValues = Array(9)
      .fill(0)
      .map(() => window.randomM0())
    this.setFeatures()
  }

  setFeatures() {
    window.metadata = {}
  }

  injectParamsToShader(shaderStr: string) {
    shaderStr = injectToShader(shaderStr, "float m0", window.m0)
    shaderStr = injectToShader(shaderStr, "float m1", window.m1)
    shaderStr = injectToShader(shaderStr, "float m2", window.m2)
    shaderStr = injectToShader(shaderStr, "float m3", window.m3)
    shaderStr = injectToShader(shaderStr, "float m4", window.m4)
    shaderStr = injectToShader(shaderStr, "float R9[9]", `float[](${this.randomValues})`)
    shaderStr = injectToShader(shaderStr, "float u_ratio", this.SIZE_RATIO)
    shaderStr = injectToShader(shaderStr, "float u_margin", this.MARGIN)

    return shaderStr
  }

  toVec3(coeff: [number, number, number]) {
    return `vec3(${coeff[0]}, ${coeff[1]}, ${coeff[2]})`
  }

  map(begin: number, end: number, value: number) {
    return (begin * (1 - value) + end * value).toFixed(8)
  }
}
